import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Register from "./components/Register";
import Login from "./components/Login";
import { useAuth } from "./context/AuthContext";
import CreatePost from "./components/CreatePost";
import PostList from "./components/PostList";
import './styles/Cyberpunk2077.css';
import EditProfile from "./components/EditProfile";
import WallPage from "./components/WallPage";
import FriendsPage from "./components/FriendsPage";
import { useState } from "react";
import { Analytics } from "@vercel/analytics/react"

// Отдельный компонент, чтобы использовать useLocation корректно
function AppWrapper() {
  return (
    <Router>
      <App />
      <Analytics /> {/* Вставляем сюда, чтобы отслеживались переходы */}
    </Router>
  );
}


function Feed() {
  return (
    <div className="feed">
      <CreatePost />
      <PostList />
    </div>
  );
}

function App() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleClick = (e, path) => {
    const el = e.currentTarget;
    el.classList.add("glitch-on-click");
    setTimeout(() => el.classList.remove("glitch-on-click"), 400);

    if (location.pathname === path) {
      // Перезагрузка компонента
      setRefreshKey((k) => k + 1);
    }
  };

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <div className="background-title">
        <h1 className="glitch-text-title">MYJOURNAL</h1>
      </div>

      <nav className="background-navbar">
        {currentUser ? (
          <>
            <Link to="/" className="nav-link" onClick={(e) => handleClick(e, "/")}>Лента</Link>
            <Link to="/profile" className="nav-link" onClick={(e) => handleClick(e, "/profile")}>Профиль</Link>
            <Link to="/wall" className="nav-link" onClick={(e) => handleClick(e, "/wall")}>Стена</Link>
            <Link to="/friends" className="nav-link" onClick={(e) => handleClick(e, "/friends")}>Друзья</Link>
          </>
        ) : (
          <>
            <Link to="/register" className="nav-link" onClick={(e) => handleClick(e, "/register")}>Регистрация</Link>
            <Link to="/login" className="nav-link" onClick={(e) => handleClick(e, "/login")}>Вход</Link>
          </>
        )}
      </nav>

      {currentUser && (
        <div className="background-welcome">
          <h2 className="welcome-text">
            <span className="welcome-greeting">ПРИВЕТ, </span>
            <span className="welcome-username">{currentUser.displayName}</span>
          </h2>
        </div>
      )}

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Feed key={refreshKey} />} />
        <Route path="/profile" element={<EditProfile key={refreshKey} />} />
        <Route path="/wall" element={<WallPage key={refreshKey} />} />
        <Route path="/friends" element={<FriendsPage key={refreshKey} />} />
        <Route path="/wall/:userId" element={<WallPage />} />
      </Routes>
    </div>
  );
}

export default AppWrapper;
